import React, { useState, useCallback } from 'react';
import PaymentForm from './PaymentForm';
import './App.css';
import PassportForm from './PassportForm';

function App() {
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [totalCost, setTotalCost] = useState(0);
  const [numVisitors, setNumVisitors] = useState(1);

  const handleNext = useCallback(() => {
    const calculatedTotalCost = numVisitors * 150;
    setTotalCost(calculatedTotalCost);
    setShowPaymentForm(true);
  }, [numVisitors]);

  const handleNumVisitorsChange = (newNumVisitors) => {
    setNumVisitors(newNumVisitors);
  };

  return (
    <div className="form-container">
      {showPaymentForm ? (
        <PaymentForm totalCost={totalCost} />
      ) : (
        <>
          <PassportForm onNext={handleNext} setNumVisitors={handleNumVisitorsChange} />
        </>
      )}
    </div>
  );
}

export default App;
